import MainBody from "./components/MainRouter";
import "./styles/App.css";

import { Route, Switch, useHistory } from "react-router-dom";

import Layout from "./components/Layout";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { theme } from "./styles/theme";
import RTL from "./components/Rtl";
import { connect } from "react-redux";

import MessageHandler from "./components/MessageHandler";
import Store from "./redux/Store";
import { popupMessagesHandler } from "./redux/General/generalActionCreators";

import withClearCache from "./ClearCache";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundryRender from "./components/ErrorBoundryRender";
import { lazy, Suspense } from "react";
// import MultiServerPage from "./components/multi_server_page";
const LoginRecovery = lazy(() => import("./Pages/register/LoginRecovery"));
const RegisterStages = lazy(() => import("./Pages/register/RegisterStages"));
const Register = lazy(() => import("./Pages/register/Register"));
const Login = lazy(() => import("./Pages/register/Login"));

const MainApp = (props) => {
  let chanel = new BroadcastChannel("isOnline");
  chanel.addEventListener("message", (e) => {
    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: "اتصال به اینترنت را چک کنید",
        color: "error",
      })
    );
  });
  // --------------------------------------------------------------------------- routes
  let routes = [];
  [
    { path: "/", comp: Login, exact: true },
    { path: "/login/getCode", comp: LoginRecovery, exact: true },
    { path: "/register", comp: Register, exact: true },
    { path: "/register/stages", comp: RegisterStages, exact: true },
  ].forEach((route, index) => {
    routes.push(
      <Route exact={route.exact} path={`${route.path}`} key={index}>
        <route.comp />
      </Route>
    );
  });
  const history = useHistory();
  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundryRender}
      onError={() => {
        history.push("/");
        localStorage.clear();
        window.location.reload();
      }}
    >
      <RTL>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          {/* {!!localStorage.MULTI_SERVER_URL ? (
            <> */}
          {!localStorage.token ? (
            <Suspense fallback={<span></span>}>
              <Switch>
                <>{routes}</>
              </Switch>
            </Suspense>
          ) : (
            <Layout>
              <MainBody />
            </Layout>
          )}
          {/* </> */}
          {/* ) : (
            <MultiServerPage />
          )} */}
          <MessageHandler />
        </ThemeProvider>
      </RTL>
    </ErrorBoundary>
  );
};
const ClearCacheComponent = withClearCache(MainApp);
function App(props) {
  return <ClearCacheComponent />;
}
const mapStateToProps = (props) => {
  let { loginReducer, generalReducer } = props;
  let { officeAuth, pwa_install } = loginReducer;
  let { multi_server_url } = generalReducer;

  return { officeAuth, pwa_install, multi_server_url };
};
export default connect(mapStateToProps)(App);
